var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "detailCanvas",
      staticClass: "detailContent canvas-box",
      attrs: { id: "detailCanvas" },
    },
    [
      _c("div", { staticClass: "title" }, [
        _c(
          "div",
          { staticClass: "title-name" },
          [
            _vm._v(_vm._s(_vm.$t("data.payin_details")) + " "),
            _c(
              "el-tag",
              {
                staticClass: "pay-status tag-custom",
                attrs: {
                  type: _vm.getPayTransactionStatusType(
                    _vm.merchantInfo.transaction_status
                  ),
                },
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.getPayTransactionStatusMap(
                        _vm.merchantInfo.transaction_status
                      )
                    )
                ),
              ]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "detail-download-container" }, [
        _c("div", { staticClass: "total" }, [
          _c("div", { staticClass: "total-item" }, [
            _c("div", { staticClass: "total-title" }, [
              _vm._v(_vm._s(_vm.$t("data.paid")) + ":"),
            ]),
            _c("div", { staticClass: "total-num " }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$store.getters.currency) +
                  " " +
                  _vm._s(
                    _vm._f("toDivideWithDot")(
                      _vm.merchantInfo.transaction_amount
                    )
                  )
              ),
            ]),
          ]),
          _c("div", { staticClass: "total-item" }, [
            _c("div", { staticClass: "total-title" }, [
              _vm._v(_vm._s(_vm.$t("data.fee")) + ":"),
            ]),
            _c("div", { staticClass: "total-num" }, [
              _vm._v(
                _vm._s(_vm.$store.getters.currency) +
                  " " +
                  _vm._s(_vm._f("toDivideWithDot")(_vm.merchantInfo.fee_split))
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "section-title mb-12 mt-12" }, [
          _vm._v(" " + _vm._s(_vm.$t("data.timeline")) + " "),
        ]),
        _c("div", { staticClass: "line-bottom-1px" }),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "item-left content-blue" }, [
            _vm._v(" " + _vm._s(_vm.$t("data.payin_created"))),
          ]),
          _c("span", { staticClass: "content-gray" }, [
            _vm._v(
              " " + _vm._s(_vm.merchantInfo.transaction_create_time) + " "
            ),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("data.payin_completed"))),
          ]),
          _c("span", { staticClass: "content-gray" }, [
            _vm._v(_vm._s(_vm.merchantInfo.transaction_return_time)),
          ]),
        ]),
        _vm.merchantInfo.transaction_status === _vm.TRANSACTION_STATUS["void"]
          ? _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "item-left content-blue" }, [
                _vm._v(_vm._s(_vm.$t("customerService.void_complete_time"))),
              ]),
              _c("span", { staticClass: "content-gray" }, [
                _vm._v(
                  _vm._s(
                    _vm.merchantInfo.trans_void_resp &&
                      _vm.merchantInfo.trans_void_resp.void_complete_time
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "section-title mb-12 mt-36" }, [
          _vm._v(" " + _vm._s(_vm.$t("data.description")) + " "),
        ]),
        _c("div", { staticClass: "line-bottom-1px" }),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "item-left content-blue" }, [
            _vm._v(_vm._s(_vm.$t("customerService.merchant_order_id"))),
          ]),
          _c("span", { staticClass: "content-gray" }, [
            _vm._v(_vm._s(_vm.merchantInfo.merchant_order_id)),
          ]),
        ]),
        _c("div", { staticClass: "item" }, [
          _c("span", { staticClass: "item-left content-blue" }, [
            _vm._v(
              _vm._s(
                _vm.merchantInfo.transaction_status ===
                  _vm.TRANSACTION_STATUS["void"]
                  ? _vm.$t("customerService.original_transaction_id")
                  : _vm.$t("customerService.transaction_id")
              )
            ),
          ]),
          _c("span", { staticClass: "content-gray" }, [
            _vm._v(_vm._s(_vm.merchantInfo.transaction_id)),
          ]),
        ]),
        _vm.merchantInfo.channel_reference_no
          ? _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "item-left content-blue" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      _vm.$store.getters.isMX
                        ? "customerService.ph_invoice_no"
                        : "customerService.invoice_no"
                    )
                  )
                ),
              ]),
              _c("span", { staticClass: "content-gray" }, [
                _vm._v(_vm._s(_vm.merchantInfo.channel_reference_no)),
              ]),
            ])
          : _vm._e(),
        _vm.merchantInfo.transaction_status === _vm.TRANSACTION_STATUS["void"]
          ? _c("div", { staticClass: "item" }, [
              _c("span", { staticClass: "item-left content-blue" }, [
                _vm._v(_vm._s(_vm.$t("customerService.void_transaction_id"))),
              ]),
              _c("span", { staticClass: "content-gray" }, [
                _vm._v(
                  _vm._s(
                    _vm.merchantInfo.trans_void_resp &&
                      _vm.merchantInfo.trans_void_resp.void_no
                  )
                ),
              ]),
            ])
          : _vm._e(),
        _c("div", { staticClass: "download-time mt-48" }, [
          _vm._v(
            _vm._s(_vm.$t("data.download_time")) +
              ": " +
              _vm._s(_vm._f("parseTime")(Date.now()))
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }